import { useReducer } from 'react';
import { HelpWith } from '@components/basicComponents';
import { HelpWithType } from '@customTypes/enums';
import type { FormFieldsProps } from '@customTypes/types';
import type { DashboardsAndMonitoringFieldsState } from '@customTypes/stateTypes';
import { helpWithOptions } from './DashboardsAndMonitoringFormOptions';

export const DashboardsAndMonitoringFormFields = (props: FormFieldsProps): JSX.Element => {
  const [state, updateState] = useReducer(
    (prev: DashboardsAndMonitoringFieldsState, newState: Partial<DashboardsAndMonitoringFieldsState>) => ({
      ...prev,
      ...newState,
    }),
    {
      helpWith: ''
    }
  );

  const helpWithChange = (option: string): void => {
    if (option === state.helpWith) {
      return;
    }

    clearFirstSelectState();
    updateState({ helpWith: option });
    props.onDetailsChange({ showDetails: true });
  };

  const clearState = (): void => {
    clearFirstSelectState();
    updateState({ helpWith: '' });
  };

  props.onReset && props.onReset(clearState);

  const clearFirstSelectState = (): void => {
    props.onDetailsChange({ showDetails: false });
  };

  return (
    <>
      <HelpWith
        selectType={!props.isConsolidated ? HelpWithType.First : HelpWithType.Second}
        options={Object.values(helpWithOptions)}
        onChange={helpWithChange}
      />
    </>
  );
};
